import React from 'react';

// import ColorPicker from 'sp-components/components/ColorPicker';
import Link from 'sp-components/components/Link';

import './styles';

export default class ProductCatalogCard extends React.Component {
  renderBlankWithLink(product, link) {
    return (
      <div className="ProductCatalogCard ui raised card sp-link">
        <div className="content">
          <Link to={link}>
            <div className="sp-header center-aligned">
              {product.title}
            </div>
          </Link>
        </div>
      </div>
    );
  }

  image(product) {
    return (
      <div className="image">
        <img src={require(`../../assets/${product.image}`)} />
      </div>
    );
  }

  // TODO: add color picker
  content(product) {
    return (
      <div className="content left-aligned">
        <div className="sp-header">{product.title}</div>
        <div className="meta">{product.sku}</div>
      </div>
    );
  }

  render() {
    const { product, blank, link } = this.props;

    if (blank) {
      return this.renderBlankWithLink(product, link);
    }

    return (
      <div className="ProductCatalogCard ui raised card">
        {this.image(product)}
        {this.content(product)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/ProductCatalogCard/index.jsx